import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../cms/store.js";
import { resetConsent } from "../consent.js";

export default function Footer() {
  const s = useContent("settings");
  const year = new Date().getFullYear();

  return (
    <footer className="site-foot">
      <div className="foot-top">
        <div>
          <Link to="/" className="logo" style={{ marginBottom: 14 }}>
            <b>
              {s.brand}
              <i>.</i>
            </b>
            <span>{s.tagline}</span>
          </Link>
          <p style={{ marginTop: 16 }}>{s.claim}</p>
          <p className="foot-note">{s.notice}</p>
        </div>

        <div>
          <h4>Serwis</h4>
          <Link to="/jak-to-dziala">Jak to działa</Link>
          <Link to="/cennik">Cennik</Link>
          <Link to="/baza-wiedzy">Baza wiedzy</Link>
          <Link to="/faq">Pytania i odpowiedzi</Link>
        </div>

        <div>
          <h4>Firma</h4>
          <Link to="/o-nas">O nas i misja</Link>
          <Link to="/kontakt">Kontakt</Link>
          <Link to="/regulamin">Regulamin</Link>
          <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
          <button type="button" className="foot-cookie-link" onClick={resetConsent}>
            Ustawienia cookies
          </button>
        </div>

        <div>
          <h4>Kontakt</h4>
          <a href={`mailto:${s.email}`}>{s.email}</a>
          <a href={`tel:${(s.phone || "").replace(/\s/g, "")}`}>{s.phone}</a>
          <p style={{ marginTop: 10 }}>
            {s.address}
            <br />
            {s.hours}
          </p>
          {(s.socials?.linkedin || s.socials?.facebook || s.socials?.x) && (
            <div className="cluster" style={{ marginTop: 10 }}>
              {s.socials.linkedin && (
                <a href={s.socials.linkedin} target="_blank" rel="noreferrer noopener">
                  LinkedIn
                </a>
              )}
              {s.socials.facebook && (
                <a href={s.socials.facebook} target="_blank" rel="noreferrer noopener">
                  Facebook
                </a>
              )}
              {s.socials.x && (
                <a href={s.socials.x} target="_blank" rel="noreferrer noopener">
                  X
                </a>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="foot-bottom">
        <div className="foot-bottom-inner">
          <span>
            © {year} {s.company}
          </span>
          <span>NIP {s.nip}</span>
          <img
            src="/paynow-belka.svg"
            alt="Płatności online obsługuje Paynow — akceptowane karty Visa, Mastercard, Maestro"
            className="foot-payments"
          />
          <div className="spacer" />
          <span>{s.seo?.title}</span>
        </div>
      </div>
    </footer>
  );
}
